import { render, staticRenderFns } from "./CliScL_List.vue?vue&type=template&id=20c249f2"
import script from "./CliScL_List.vue?vue&type=script&lang=js"
export * from "./CliScL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports